import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, X } from 'lucide-react';
import { OfferForm } from '../../components/admin/OfferConfigurator';
const mockOffers = [{
  id: 1,
  consumer: 'Lissette Berpan',
  type: 'Settlement',
  amount: 2500.0,
  dueDate: 'Jun 15, 2026',
  priority: true,
  status: 'Active'
}, {
  id: 2,
  consumer: 'Michael Chang',
  type: 'Payment Plan',
  amount: 1250.0,
  dueDate: 'Jul 1, 2026',
  priority: false,
  status: 'Active'
}, {
  id: 3,
  consumer: 'David Smith',
  type: 'Pay in Full',
  amount: 850.5,
  dueDate: 'Jun 20, 2026',
  priority: false,
  status: 'Active'
}];
export function Offers() {
  const [activeTab, setActiveTab] = useState<'active' | 'settled'>('active');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.get('create') === '1') {
      setIsDrawerOpen(true);
      const next = new URLSearchParams(searchParams);
      next.delete('create');
      setSearchParams(next, {
        replace: true
      });
    }
  }, [searchParams, setSearchParams]);
  return <div className="p-8 max-w-[1600px] mx-auto flex flex-col h-full" data-id="element-1333">
      <div className="flex items-center justify-between mb-6 shrink-0" data-id="element-1334">
        <h1 className="text-2xl font-bold text-brand-navy" data-id="element-1335">Offers & Plans</h1>
        <button onClick={() => setIsDrawerOpen(true)} className="flex items-center gap-2 bg-brand-red hover:bg-red-800 text-white px-4 py-2 rounded-lg text-sm font-bold transition-colors shadow-sm" data-id="element-1336">
          <Plus size={16} data-id="element-1337" />
          Create Offer
        </button>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b border-gray-200 mb-6 shrink-0" data-id="element-1338">
        <button onClick={() => setActiveTab('active')} className={`pb-3 text-sm font-bold transition-colors relative ${activeTab === 'active' ? 'text-brand-red' : 'text-gray-500 hover:text-brand-navy'}`} data-id="element-1339">
          Active Offers
          {activeTab === 'active' && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-red" data-id="element-1340"></div>}
        </button>
        <button onClick={() => setActiveTab('settled')} className={`pb-3 text-sm font-bold transition-colors relative ${activeTab === 'settled' ? 'text-brand-red' : 'text-gray-500 hover:text-brand-navy'}`} data-id="element-1341">
          Settled / Expired
          {activeTab === 'settled' && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-red" data-id="element-1342"></div>}
        </button>
      </div>

      {/* Table */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex-1 flex flex-col" data-id="element-1343">
        <div className="overflow-x-auto flex-1" data-id="element-1344">
          <table className="w-full text-left border-collapse" data-id="element-1345">
            <thead data-id="element-1346">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1347">
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1348">
                  Consumer
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1349">
                  Offer Type
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1350">
                  Amount
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1351">
                  Due Date
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1352">
                  Priority
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-1353">
                  Status
                </th>
                <th className="px-6 py-4 text-xs font-bold text-gray-500 uppercase tracking-wider text-right" data-id="element-1354">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1355">
              {mockOffers.map(o => <tr key={o.id} className="hover:bg-gray-50 transition-colors" data-id="element-1356">
                  <td className="px-6 py-4 text-sm font-bold text-brand-navy" data-id="element-1357">
                    {o.consumer}
                  </td>
                  <td className="px-6 py-4" data-id="element-1358">
                    <span className={`px-2.5 py-1 rounded text-xs font-bold uppercase tracking-wider border ${o.type === 'Settlement' ? 'bg-green-50 text-green-700 border-green-100' : o.type === 'Payment Plan' ? 'bg-blue-50 text-blue-700 border-blue-100' : 'bg-gray-100 text-gray-700 border-gray-200'}`} data-id="element-1359">
                      {o.type}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-brand-dark" data-id="element-1360">
                    $
                    {o.amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2
                })}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-1361">
                    {o.dueDate}
                  </td>
                  <td className="px-6 py-4" data-id="element-1362">
                    {o.priority ? <span className="px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 text-xs font-bold border border-amber-100" data-id="element-1363">
                        Priority
                      </span> : <span className="text-gray-400 text-sm" data-id="element-1364">-</span>}
                  </td>
                  <td className="px-6 py-4" data-id="element-1365">
                    <span className="px-2.5 py-1 rounded-full bg-green-50 text-green-700 text-xs font-bold border border-green-100 flex items-center gap-1 w-fit" data-id="element-1366">
                      <span className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-1367"></span>
                      {o.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right space-x-3" data-id="element-1368">
                    <button className="text-sm font-semibold text-brand-navy hover:text-brand-red transition-colors" data-id="element-1369">
                      Edit
                    </button>
                    <button className="text-sm font-semibold text-gray-500 hover:text-brand-red transition-colors" data-id="element-1370">
                      Deactivate
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Drawer */}
      <AnimatePresence data-id="element-1371">
        {isDrawerOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-[#1a2332]/40 backdrop-blur-sm z-40" onClick={() => setIsDrawerOpen(false)} data-id="element-1372" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed inset-y-0 right-0 w-full max-w-3xl bg-white shadow-2xl z-50 flex flex-col border-l border-gray-200" data-id="element-1373">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0 bg-gray-50" data-id="element-1374">
                <h2 className="text-lg font-bold text-brand-navy" data-id="element-1375">
                  Create Settlement Offers
                </h2>
                <button onClick={() => setIsDrawerOpen(false)} className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-200 transition-colors" data-id="element-1376">
                  <X size={20} data-id="element-1377" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-6" data-id="element-1378">
                <OfferForm onClose={() => setIsDrawerOpen(false)} data-id="element-1379" />
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}